/**
 * In-memory hand-off of the password between the set-password form and the
 * `/verify-phone` OTP step.
 *
 * The set-password submit stashes the entered password here, then navigates to
 * `/verify-phone` with router state that excludes the password. The verify page
 * reads the password back without consuming it, because verify may be retried
 * after a `rejected` OTP, and submits it on `POST <apiPrefix>/auth/signup/verify`.
 *
 * ponytail: a module-level variable that is never persisted, so a hard refresh
 * drops the password and the verify page sends the user back to a clean
 * restart. React Router v7 writes `location.state` into
 * `window.history.state.usr` and restores it on reload, so router state, like
 * sessionStorage, would keep the plaintext password in the browser.
 */
let pending: string | null = null;

/** Stash the password for the upcoming OTP-verify step. */
export function setSignupPassword(pw: string): void {
  pending = pw;
}

/**
 * Read the stashed password without consuming it, so each verify retry can
 * call it. Null when unset or after a reload.
 */
export function getSignupPassword(): string | null {
  return pending;
}

/** Drop the stashed password (call after a successful signup). */
export function clearSignupPassword(): void {
  pending = null;
}
